// extracted by mini-css-extract-plugin
module.exports = {"IconWrapper":"SummaryCard_IconWrapper__N_7YU","Icon":"SummaryCard_Icon__1JN0y"};